module.exports = __webpack_public_path__ + "media/ilke.71498807.mp4";